module.exports = __webpack_public_path__ + "img/carolina.34910a6.png";